import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'

import { cn } from '@/lib/ui/style-helpers'

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('inline-flex items-center justify-center', className)}
    data-testid='tabs-list'
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, value, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'inline-flex h-10 items-center space-x-1 px-3 py-3',
      'text-main-foreground-tertiary !text-label-default',
      'hover:text-main-foreground-primary',
      'disabled:text-main-foreground-disabled',
      'disabled:hover:text-main-foreground-disabled',
      '[&:disabled]:hover:text-main-foreground-disabled',
      '[&:disabled_*]:text-main-foreground-disabled',
      '[&:disabled_*]:hover:text-main-foreground-disabled',
      className,
    )}
    data-testid={`tab-trigger-${value}`}
    value={value}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, value, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      // Radix always renders the panel; `hidden` alone loses to a caller's display utility.
      'data-[state=inactive]:hidden',
      className,
    )}
    data-testid={`tab-content-${value}`}
    value={value}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
